module.exports = __webpack_public_path__ + "static/img/uoloadAvatar.12e70f82.png";